import { AjouterEnfantCommand } from '@app/features/editeur/models/commands/ajouter-enfant-command';
import { Enfant } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { ObjetMaquette } from '../objet-maquette.model';
import { UndoCommand } from './command';
import { CommandEvents } from './command-events';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';

export class RetirerEnfantCommand implements UndoCommand<ObjetMaquette> {
    private revertedCommand: AjouterEnfantCommand;

    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        enfant: Enfant,
        ignoreConflict: boolean
    ) {
        this.revertedCommand = new AjouterEnfantCommand(codeStructure, id, version, events, objetMaquetteService, enfant, ignoreConflict);
    }

    do(): Observable<ObjetMaquette> {
        return this.revertedCommand.undo();
    }

    undo(): Observable<ObjetMaquette> {
        return this.revertedCommand.do();
    }

    destroy(): void {
        this.revertedCommand.destroy();
    }
}
